<template>
  <div id="contact">
    <navigation></navigation>
    <banner mainen="CONTACT" mainzh="联系我们"></banner>
    <div id="main-contact">
      <div class="contact-container">
        <div class="contact-info">
          <div class="show-img">
            <img src="@/assets/imgs/b12.png" alt="" />
          </div>
          <div class="info-message">
            <div class="one">
              <div class="icon">
                <img src="@/assets/imgs/address.png" alt="" />
              </div>
              <div class="info-text">
                <div class="info-text-title">地址：</div>
                <div class="info-text-content">
                  {{footerData.address}}
                </div>
              </div>
            </div>
            <div class="one">
              <div class="icon">
                <img src="@/assets/imgs/address.png" alt="" />
              </div>
              <div class="info-text">
                <div class="info-text-title">电话：</div>
                <div class="info-text-content">
                  {{footerData.tel}}
                </div>
              </div>
            </div>
            <div class="one">
              <div class="icon">
                <img src="@/assets/imgs/address.png" alt="" />
              </div>
              <div class="info-text">
                <div class="info-text-title">手机：</div>
                <div class="info-text-content">
                  {{footerData.time}}
                </div>
              </div>
            </div>
            <div class="one">
              <div class="icon">
                <img src="@/assets/imgs/address.png" alt="" />
              </div>
              <div class="info-text">
                <div class="info-text-title">邮箱：</div>
                <div class="info-text-content">
                  {{footerData.email}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <vfooter></vfooter>
  </div>
</template>
<script>
import navigation from "@/components/sub/Nav";
import vfooter from "@/components/sub/Footer";
import banner from "@/components/sub/Banner";
export default {
  name: "",
  components: {
    navigation,
    vfooter,
    banner,
  },
  data() {
    return {
      footerData:{}
    };
  },
  mounted(){
    this.getData();
  },
  methods:{
    getData() {
      this.axios
        .get(this.$host + "/api/index/contact")
        .then((res) => {
          this.footerData = res.data.data;
          console.log(this.footerData);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    
  }
};
</script>
<style scoped>
#main-contact {
  width: 1200px;
  margin: 0 auto;
}
#main-contact .contact-container {
  padding: 30px 120px;
}

#main-contact .contact-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

#main-contact .contact-info .show-img {
  width: 568px;
  height: 402px;
}
#main-contact .contact-info .show-img img {
  width: 100%;
  height: 100%;
}

#main-contact .contact-info .info-message {
  padding-bottom: 32px;
}

#main-contact .contact-info .one {
  display: flex;
  justify-content:flex-start;
  margin-top: 40px;
}

#main-contact .contact-info .one .icon {
  display: flex;
  align-items: flex-end;
  padding-bottom: 10px;
  margin-right: 30px;
}

#main-contact .contact-info .one .info-text .info-text-title {
  font-size: 18px;
  color: #333;
  font-weight: bold;
}

#main-contact .contact-info .one .info-text .info-text-content {
  font-size: 16px;
  color: #333;
  weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/page/Contact.vue